// import { camelToSnake } from 'src/helpers/functions/camel-to-snake'
import { camelToSnake } from '../../../helpers/functions/camel-to-snake'
import { graphClient } from '../../graph-client'
import {
  GET_GIFT_SENT_RANKING_HOST_BY_LIVE_BETWEEN_DATE,
  GET_GIFT_SENT_RANKING_SPECTATOR_BY_LIVE_BETWEEN_DATE,
  GET_LIVE_POINTS,
  GET_MULTI_LIVE_TROPHY,
} from './gql'
import type {
  GetGiftSentLiveRankingHost,
  GetGiftSentLiveRankingHostSumAll,
  GetGiftSentLiveRankingSpectator,
  GetLivePoints,
} from './types'

class GiftSentRankingLiveService {
  async getSpectatorLive({
    initialDate,
    finalDate,
    liveId,
  }: GetGiftSentLiveRankingSpectator.Input) {
    const request =
      await graphClient.request<GetGiftSentLiveRankingSpectator.Output>(
        GET_GIFT_SENT_RANKING_SPECTATOR_BY_LIVE_BETWEEN_DATE,
        {
          initialDate,
          finalDate,
          liveId: Number(liveId),
        },
      )

    return request?.getGiftSentRankingSpectatorByLiveBetweenDate
  }

  async getHostLive({
    initialDate,
    finalDate,
    liveId,
  }: GetGiftSentLiveRankingHost.Input) {
    // const client = await graphClient()
    const request =
      await graphClient.request<GetGiftSentLiveRankingHost.Output>(
        GET_GIFT_SENT_RANKING_HOST_BY_LIVE_BETWEEN_DATE,
        {
          initialDate,
          finalDate,
          liveId: Number(liveId),
        },
      )

    return request?.getGiftSentRankingHostByLiveBetweenDate
  }

  async getMultiLiveTrophy({
    initialDate,
    finalDate,
    typeLive,
    userReceivedId,
  }: GetGiftSentLiveRankingHostSumAll.Input) {
    // const client = await graphClient()
    const request =
      await graphClient.request<GetGiftSentLiveRankingHostSumAll.Output>(
        GET_MULTI_LIVE_TROPHY,
        {
          initialDate,
          finalDate,
          userReceivedId,
          typeLive: camelToSnake(typeLive as string),
        },
      )

    return request?.getMultiLiveTrophy
  }

  async getLivePoints({ liveId }: GetLivePoints.Input) {
    // const client = await graphClient()

    const response = await graphClient.request<GetLivePoints.Output>(
      GET_LIVE_POINTS,
      {
        liveId: Number(liveId),
      },
    )

    return response?.getLive
  }
}

export const giftSentRankingLiveService = new GiftSentRankingLiveService()
